import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { AdminLayout } from "./AdminLayout";
import api from "@/lib/api";
import { inputCls, fmt } from "@/components/portal/PortalUI";
import { Search } from "lucide-react";

export default function Students() {
  const [rows, setRows] = useState([]);
  const [search, setSearch] = useState("");
  const [program, setProgram] = useState("");
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    const t = setTimeout(() => api.get("/admin/students", { params: { search, program } }).then((r) => setRows(r.data)).finally(() => setLoading(false)), 250);
    return () => clearTimeout(t);
  }, [search, program]);
  return (
    <AdminLayout title="Enrolled Students">
      <div className="flex flex-wrap gap-3 mb-5">
        <div className="relative flex-1 min-w-[220px]"><Search size={16} className="absolute left-3 top-3 text-navy/40" />
          <input value={search} onChange={(e) => setSearch(e.target.value)} placeholder="Search name, email, reference" className={`${inputCls} pl-9`} data-testid="students-search" /></div>
        <select value={program} onChange={(e) => setProgram(e.target.value)} className={`${inputCls} max-w-xs`} data-testid="students-program-filter">
          <option value="">All programs</option><option>AAWTA Certified Dispatcher Program</option><option>Mentorship or Career Pathway Support</option>
        </select>
      </div>
      <div className="bg-white rounded-lg border border-navy/10 shadow-sm overflow-x-auto">
        <table className="w-full text-sm" data-testid="students-table">
          <thead className="bg-navy-light text-navy"><tr>{["Student", "Programs", "Cohort", "Instructor / Mentor", "Registration", "Documents", "Enrolled"].map((h) => <th key={h} className="text-left font-semibold px-4 py-3 whitespace-nowrap">{h}</th>)}</tr></thead>
          <tbody className="divide-y divide-navy/5">
            {rows.map((s) => (
              <tr key={s.student_id} className="hover:bg-soft-gray" data-testid={`student-row-${s.student_id}`}>
                <td className="px-4 py-3"><Link to={`/admin/students/${s.student_id}`} className="font-semibold text-navy hover:text-magenta">{s.name}</Link><p className="text-xs text-dark-text/50">{s.email}</p></td>
                <td className="px-4 py-3 text-xs">{s.programs.join(", ")}</td>
                <td className="px-4 py-3">{s.cohort || "—"}</td>
                <td className="px-4 py-3 text-xs">{s.instructor_name || s.instructor_email || "—"}<br /><span className="text-dark-text/50">{s.mentor_name || s.mentor_email || ""}</span></td>
                <td className="px-4 py-3 text-xs font-semibold">{s.registration_status}</td>
                <td className="px-4 py-3 text-xs">{s.docs_done}/{s.docs_total}{s.docs_overdue > 0 && <span className="ml-2 text-red-600 font-bold">{s.docs_overdue} overdue</span>}</td>
                <td className="px-4 py-3 text-xs">{fmt(s.enrolled_at)}</td>
              </tr>
            ))}
          </tbody>
        </table>
        {!loading && rows.length === 0 && <p className="p-6 text-sm text-dark-text/50" data-testid="students-empty">No enrolled students in your view yet.</p>}
      </div>
    </AdminLayout>
  );
}
